import { render, staticRenderFns } from "./SupplierTypeIndex.vue?vue&type=template&id=6a6d2c92&scoped=true&"
import script from "./SupplierTypeIndex.vue?vue&type=script&lang=js&"
export * from "./SupplierTypeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6d2c92",
  null
  
)

export default component.exports